
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { useMedia } from "./context";
import { MediaType } from "./types/mediaTypes";

const MediaFilter: React.FC = () => {
  const { t } = useLanguage();
  const { activeFilter, setActiveFilter } = useMedia();

  const handleFilterChange = (filter: MediaType) => {
    setActiveFilter(filter);
  };

  const filterButton = (filter: MediaType, label: string) => (
    <button
      onClick={() => handleFilterChange(filter)}
      className={`px-4 py-2 rounded-full transition-all ${
        activeFilter === filter
          ? "bg-palsustain-green text-white"
          : "bg-palsustain-beige/50 text-palsustain-charcoal hover:bg-palsustain-beige"
      }`}
    >
      {label}
    </button>
  );

  return (
    <section className="py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-3">
          {filterButton("all", t("media.filter.all"))}
          {filterButton("infographic", t("media.filter.infographics"))}
          {filterButton("photo", t("media.filter.photos"))}
          {filterButton("video", t("media.filter.videos"))}
        </div>
      </div>
    </section>
  );
};

export default MediaFilter;
